<table>
  <thead>
  <tr>
    <th scope="col"></th>
    @for (column of layout().tileTable.columns; track $index) {
      <th scope="col">{{ column.columnHeader }}</th>
    }
  </tr>
  </thead>
  <tbody>
    @for (header of layout().tileTable.rowHeaders; track $index) {
      @let rowIndex = $index;
      <tr>
        <th data-test="data-point-measure-name">
          {{ header }}
        </th>

        @for (column of layout().tileTable.columns; track $index) {
          @let measure = column.measures[rowIndex];
          @let value = dataPoints() | selectValue: measure.code : layout().periodCode : layout().date;

          <td
            data-test="data-point-value"
            [attr.data-value]="value"
          >
            {{ value | formatByMeasure: measure }}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
